import {configureSessionVersion} from '@/utils/sessionSecurity';
export default {
    mounted() {
        this.$store.dispatch('appVersion/start');
        configureSessionVersion(response => {
            this.$store.dispatch('appVersion/syncServerVersion', response.headers);
            this.$store.dispatch('appVersion/syncUpdateError', response);
        }, () => Boolean(this.$store.state.appVersion.isUpdateRequired));
        this.httpResponseInterceptor = this.$http.interceptors.response.use(res => {
            this.$store.dispatch('appVersion/syncServerVersion', res.headers);
            return res;
        }, err => {
            if (err.response) {
                this.$store.dispatch('appVersion/syncServerVersion', err.response.headers);
                this.$store.dispatch('appVersion/syncUpdateError', err.response);
            }
            return Promise.reject(err);
        });
    },
    beforeDestroy() {
        this.$store.dispatch('appVersion/stop');
        this.$http.interceptors.response.eject(this.httpResponseInterceptor);
    }
};
